import './App.css';
import { RouterProvider } from "react-router-dom";
import router from "./routes/AppRoutes";
import { AuthProvider } from "./routes/AuthContext";
import NavigationScroll from './layout/NavigationScroll';
import HTTPLoader from './ui-component/HttpRequestLoader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import theme from "./ui-component/Theme";
import { ThemeProvider } from "@mui/material/styles";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <AuthProvider> 
    <ThemeProvider theme={theme}>
      <NavigationScroll>
        <HTTPLoader />
        
        <RouterProvider router={router} />
        <ToastContainer />
      </NavigationScroll>
    </ThemeProvider>
  </AuthProvider>
  );
}

export default App;